'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useMemo } from 'react'
import type { Color, Look } from '../types/Color'
import { getModelHeight } from '../utils/getModelHeight/getModelHeight'
import { getModelSize } from '../utils/getModelSize/getModelSize'

interface ModelSizes {
	modelHeight?: string
	modelSizeCode?: string
}

export const useModelInfo = ({
	selectedColor,
	selectedLook,
}: {
	selectedColor?: Color
	selectedLook?: Look
}): ModelSizes => {
	const {
		country: { measurementUnits },
	} = useMasterData()
	const sizeInInches = measurementUnits?.sizeInInches ?? false

	const modelSizes: ModelSizes = useMemo(() => {
		if (!selectedColor || !selectedLook) {
			return {}
		}
		return {
			modelHeight: getModelHeight({
				selectedLook,
				sizeInInches,
			}),
			modelSizeCode: getModelSize({ selectedColor, selectedLook }),
		}
	}, [selectedColor, selectedLook, sizeInInches])

	return modelSizes
}
